export const toCurrency = x => {
  if (typeof x === 'undefined') return '';
  const val = x.toString().replace(/([a-zA-Z]|,)/g, '');
  if (!isNaN(parseInt(val, 10))) {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return val;
};

export const toPounds = x => {
  if (typeof x === 'undefined' || toCurrency(x) === '') return '';
  return `£${toCurrency(x)}`;
};

export const toPct = x => {
  if (typeof x === 'undefined' || toCurrency(x) === '') return '';
  return `${toCurrency(x).replace(/0*$/g, '').replace(/\.$/,'')}%`;
};



// WEBPACK FOOTER //
// ./src/services/Formats.js